import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  FormGroup,
  Badge,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import {
  resetSystemUsers,
  resetError,
  getSystemUsers,
  activateSystemUser,
} from "../../store/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import ProfilePicture from "../../components/Common/ProfilePicture";
//Moment
import Moment from "react-moment";

const SystemUsers = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataSystemUser,
    dataSystemUserActivate,
    loadingSystemUser,
    loadingSystemUserActivate,
    errorSystemUser,
    successSystemUser,
  } = useSelector((state) => state.SystemUser);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [systemUserId, setSystemUserId] = useState();
  const [systemUserName, setSystemUserName] = useState();

  const [nameFilter, setNameFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [nicknameFilter, setNicknameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const [active, setActive] = useState();
  const [status, setStatus] = useState();

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successSystemUser && dispatch(resetSystemUsers()) && handleFilter(),
  };

  const handleFilter = (name, email, nickname) => {
    setNameFilter(name);
    setEmailFilter(email);
    setNicknameFilter(nickname);
    setPage(1);
    dispatch(getSystemUsers(1, qtdDefault, name, email, nickname));
  };

  const handleActivate = () => {
    dispatch(activateSystemUser(systemUserId, active));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setSystemUserIdName = (systemuser) => {
    setSystemUserId(systemuser.id);
    setSystemUserName(systemuser.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(
      getSystemUsers(value, qtdDefault, nameFilter, emailFilter, nicknameFilter)
    );
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataSystemUser && dataSystemUser.paging) {
      if (page < dataSystemUser.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataSystemUserActivate && dataSystemUserActivate.message) {
      showToast("success", t(dataSystemUserActivate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successSystemUser]);

  useEffect(() => {
    if (errorSystemUser && typeof errorSystemUser === "object") {
      errorSystemUser.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "not found" && showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorSystemUser) {
        showToast("error", t(errorSystemUser));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorSystemUser]);

  useEffect(() => {
    if (dataSystemUser !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataSystemUser]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/systemusers"
            title={t("Dashboard")}
            breadcrumbItem={t("System users")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name, values.email, values.nickname);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Email")}
                            id="email"
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder={t("Email") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="6" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Nickname")}
                            id="nickname"
                            name="nickname"
                            type="text"
                            className="form-control"
                            placeholder={t("Nickname") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Nickname must be composed only with letters and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="6"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="new-systemuser">
                          <Link to="/systemuser">
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add System User")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>
                              <span className="ml-2">{"#"}</span>
                            </th>
                            <th>{t("Name")}</th>
                            <th>{t("Email")}</th>
                            <th>{t("Nickname")}</th>
                            <th>{t("Profile")}</th>
                            <th>{t("Last Login")}</th>
                            <th>{t("Status")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingSystemUser ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataSystemUser &&
                            dataSystemUser.systemUsers &&
                            dataSystemUser.systemUsers.length > 0 ? (
                            dataSystemUser.systemUsers.map(
                              (systemuser, key) => (
                                <tr key={key}>
                                  <td>
                                    <ProfilePicture
                                      name={systemuser.name}
                                      src={systemuser.url_avatar}
                                    />
                                  </td>
                                  <td>{systemuser.name}</td>
                                  <td>
                                    <Link
                                      to="#"
                                      className="text-body font-weight-bold"
                                    >
                                      {systemuser.email}
                                    </Link>
                                  </td>
                                  <td>{systemuser.nickname}</td>
                                  <td>
                                    {systemuser.profiles.map((e, key) => (
                                      <Badge
                                        key={key}
                                        color="success"
                                        className="font-size-12"
                                      >
                                        {e.name}
                                      </Badge>
                                    ))}
                                  </td>
                                  <td>
                                    {systemuser.last_login && (
                                      <Moment format={t("date")} locale="pt-br">
                                        {systemuser.last_login}
                                      </Moment>
                                    )}
                                  </td>
                                  <td>
                                    <div
                                      className="custom-control custom-switch"
                                      dir="ltr"
                                    >
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id={"customSwitch" + systemuser.id}
                                        readOnly
                                        checked={
                                          systemuser.active === "1"
                                            ? true
                                            : false
                                        }
                                        onClick={() => {
                                          setSystemUserIdName(systemuser);
                                          toggleModal();
                                          setStatus(
                                            systemuser.active === "1"
                                              ? t("deactivate")
                                              : t("activate")
                                          );
                                          setActive(
                                            systemuser.active === "1"
                                              ? { active: false }
                                              : { active: true }
                                          );
                                        }}
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor={"customSwitch" + systemuser.id}
                                      >
                                        {systemuser.active === "1"
                                          ? t("Active")
                                          : t("Inactive")}
                                      </label>
                                    </div>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/systemuser/${systemuser.id}`}
                                      className="text-primary text-center"
                                      id="edit"
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-18 px-2"
                                        id="edittooltip"
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="edittooltip"
                                      >
                                        {t("Edit")}
                                      </UncontrolledTooltip>
                                    </Link>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingSystemUserActivate}>
                        <div className="modal-body font-size-18 text-center">
                          {`${t("Do you want to")} ${status} `}
                          <strong> {systemUserName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingSystemUserActivate ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (systemUserId) handleActivate();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {dataSystemUser &&
                  dataSystemUser.paging &&
                  dataSystemUser.paging.length > 1 ? (
                    <Pagination className="pagination pagination-rounded justify-content-end my-2">
                      <PaginationItem onClick={handlePreviousPage}>
                        <PaginationLink previous />
                      </PaginationItem>

                      {dataSystemUser &&
                        dataSystemUser.paging &&
                        dataSystemUser.paging.map((value, index) => {
                          return (
                            <PaginationItem
                              key={index}
                              onClick={() => {
                                handlePage(value);
                              }}
                              active={page === value ? true : false}
                            >
                              <PaginationLink
                                key={index}
                                style={{ display: "inline" }}
                              >
                                {value}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        })}
                      <PaginationItem onClick={handleNextPage}>
                        <PaginationLink next />
                      </PaginationItem>
                    </Pagination>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(SystemUsers);
